import { render, staticRenderFns } from "./orgTreeShow.vue?vue&type=template&id=716c98d4&scoped=true"
import script from "./orgTreeShow.vue?vue&type=script&lang=js"
export * from "./orgTreeShow.vue?vue&type=script&lang=js"
import style0 from "./orgTreeShow.vue?vue&type=style&index=0&id=716c98d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716c98d4",
  null
  
)

export default component.exports